import { render, staticRenderFns } from "./document-account-list.vue?vue&type=template&id=5f676e94&scoped=true&"
import script from "./js/document-account-list.js?vue&type=script&lang=js&"
export * from "./js/document-account-list.js?vue&type=script&lang=js&"
import style0 from "./document-account-list.vue?vue&type=style&index=0&id=5f676e94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f676e94",
  null
  
)

export default component.exports